module.exports = __webpack_public_path__ + "static/caldwell-b50bb3171a6ffab01aea0963fab4f994.jpg";